import React from 'react';
import { FraudOutlineIcon } from '@common-fe/common-fe';

import TopbarIconButton from '../../EmployeeTopbar/TopbarIconButton';

interface Props {
  onClick: () => void;
}

const FraudFlagButton: React.FC<Props> = ({ onClick }) => (
  <TopbarIconButton
    onClick={onClick}
    testId="fraud-review_flag"
    title="Flag for Fraud"
    icon={<FraudOutlineIcon size="24px" color="iconPrimary" />}
  />
);

export default FraudFlagButton;
